// extracted by mini-css-extract-plugin
export default {"compactTable":"emetSuccess_compactTable__F0MBH","compactTable1":"emetSuccess_compactTable1__R+b9N","centerItems":"emetSuccess_centerItems__LXHkR"};